<template>
	<section class="other_page_banner riskban_sec">
		<div class="container">
			<div class="row">
				<div
					class="col-sm-12 col-xxl-6 col-xl-6 col-lg-6 col-md-7 order-2 order-md-1"
				>
					<div class="ban_lt">
						<h5>
							{{ $t('new_ui.business_risk_page.section_banner.title.one') }}
						</h5>
						<h2>
							{{
								$t('new_ui.business_risk_page.section_banner.main_title.one')
							}}
						</h2>
						<h6>
							{{ $t('new_ui.business_risk_page.section_banner.sub_title.one') }}
							<span>{{
								$t('new_ui.business_risk_page.section_banner.sub_title.two')
							}}</span>
						</h6>
						<p>
							{{ $t('new_ui.business_risk_page.section_banner.paragraph.one') }}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center p-top"
						></div>
					</div>
				</div>
				<div
					class="col-sm-12 col-xxl-6 col-xl-6 col-lg-6 col-md-5 order-1 order-md-2"
				>
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="question_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-4 question_desk">
					<div class="question_lt">
						<img :src="img.image2" alt="" />
					</div>
				</div>
				<div class="col-sm-4 question_mob">
					<div class="question_lt">
						<img :src="img.image7" alt="" />
					</div>
				</div>
				<div class="col-sm-8">
					<div class="question_rt">
						<div class="payment_world_right">
							<span>{{
								$t('new_ui.business_risk_page.question_sec.label')
							}}</span>
							<div class="payment_world_txt">
								<h4>
									{{ $t('new_ui.business_risk_page.question_sec.title.one') }}
									<span>{{
										$t('new_ui.business_risk_page.question_sec.title.two')
									}}</span>
								</h4>

								<div class="starting_to_btn pay_world">
									<a href="/auth/register">{{
										$t('new_ui.business_risk_page.question_sec.cta_buttons.one')
									}}</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="credit_system">
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="deposit_recipients">
						<span>{{
							$t('new_ui.business_risk_page.credit_system.label')
						}}</span>
						<h5>
							{{ $t('new_ui.business_risk_page.credit_system.title.one') }}
							<span>{{
								$t('new_ui.business_risk_page.credit_system.title.two')
							}}</span>
						</h5>
						<p>
							{{ $t('new_ui.business_risk_page.credit_system.paragraph.one') }}
							<br />{{
								$t('new_ui.business_risk_page.credit_system.paragraph.two')
							}}
						</p>
					</div>
				</div>
			</div>
			<div class="row d-none d-md-flex">
				<div class="col-sm-6">
					<div class="creditcard_system_inn credit_system_rt">
						<span>{{
							$t('new_ui.business_risk_page.credit_system_lt.label')
						}}</span>
						<div class="creditcard_system_txt">
							<h4>
								{{ $t('new_ui.business_risk_page.credit_system_lt.title.one') }}
								<span>{{
									$t('new_ui.business_risk_page.credit_system_lt.title.two')
								}}</span>
							</h4>
							<p>
								{{ $t('new_ui.business_risk_page.credit_system_lt.paragraph') }}
							</p>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t(
										'new_ui.business_risk_page.credit_system_lt.cta_buttons.one',
									)
								}}</a>
							</div>
							<img :src="img.image4" alt="" />
						</div>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="creditcard_system_inn credit_system_rt">
						<img :src="img.image3" alt="" />
						<span>{{
							$t('new_ui.business_risk_page.credit_system_rt.label')
						}}</span>
						<div class="creditcard_system_txt">
							<h4>
								{{ $t('new_ui.business_risk_page.credit_system_rt.title.one') }}
								<span>{{
									$t('new_ui.business_risk_page.credit_system_rt.title.two')
								}}</span>
							</h4>
							<p>
								{{ $t('new_ui.business_risk_page.credit_system_rt.paragraph') }}
							</p>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t(
										'new_ui.business_risk_page.credit_system_rt.cta_buttons.one',
									)
								}}</a>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row d-block d-md-none">
				<div class="col-sm-12 border_dash">
					<div class="row">
						<div class="enjoy_slider">
							<swiper
								:slides-per-view="1"
								:space-between="30"
								:loop="true"
								:pagination="{
									el: '.swiper-pagination-2',
									clickable: true,
								}"
								:autoplay="{ delay: 2000, disableOnInteraction: false }"
								:breakpoints="{
									0: { slidesPerView: 1 },
									600: { slidesPerView: 1.5 },
									768: { slidesPerView: 2 },
									1000: { slidesPerView: 3 },
									1200: { slidesPerView: 4.5 },
								}"
							>
								<swiper-slide>
									<div class="creditcard_system_inn credit_system_rt">
										<img class="d-block d-md-none" :src="img.image4" alt="" />
										<span>{{
											$t('new_ui.business_risk_page.credit_system_lt.label')
										}}</span>
										<div class="creditcard_system_txt">
											<h4>
												{{
													$t(
														'new_ui.business_risk_page.credit_system_lt.title.one',
													)
												}}
												<span>{{
													$t(
														'new_ui.business_risk_page.credit_system_lt.title.two',
													)
												}}</span>
											</h4>
											<p>
												{{
													$t(
														'new_ui.business_risk_page.credit_system_lt.paragraph',
													)
												}}
											</p>
											<div class="starting_to_btn">
												<a href="/auth/register">{{
													$t(
														'new_ui.business_risk_page.credit_system_lt.cta_buttons.one',
													)
												}}</a>
											</div>
											<img class="d-none d-md-block" :src="img.image4" alt="" />
										</div>
									</div>
								</swiper-slide>
								<swiper-slide>
									<div class="creditcard_system_inn credit_system_rt">
										<img :src="img.image3" alt="" />
										<span>{{
											$t('new_ui.business_risk_page.credit_system_rt.label')
										}}</span>
										<div class="creditcard_system_txt">
											<h4>
												{{
													$t(
														'new_ui.business_risk_page.credit_system_rt.title.one',
													)
												}}
												<span>{{
													$t(
														'new_ui.business_risk_page.credit_system_rt.title.two',
													)
												}}</span>
											</h4>
											<p>
												{{
													$t(
														'new_ui.business_risk_page.credit_system_rt.paragraph',
													)
												}}
											</p>
											<div class="starting_to_btn">
												<a href="/auth/register">{{
													$t(
														'new_ui.business_risk_page.credit_system_rt.cta_buttons.one',
													)
												}}</a>
											</div>
										</div>
									</div>
								</swiper-slide>
							</swiper>
							<!-- Move pagination outside swiper -->
							<div class="swiper-pagination-2"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.business_risk_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t('new_ui.business_risk_page.section_newsletter.title.one')
								}}</span>
								{{
									$t('new_ui.business_risk_page.section_newsletter.title.two')
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.business_risk_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.business_risk_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.business_risk_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.business_risk_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import riskban from '@/assets/images/sub/riskban.png';
import paydiagram from '@/assets/images/sub/pay_diagram.png';
import rich1 from '@/assets/images/sub/rich1.png';
import rich2 from '@/assets/images/sub/rich2.png';
import bpaydia from '@/assets/images/sub/bpay_dia.png';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
SwiperCore.use([Autoplay, Pagination]);
export default {
	data: () => {
		return {
			img: {
				image1: riskban,
				image2: paydiagram,
				image3: rich1,
				image4: rich2,
				image7: bpaydia,
			},
		};
	},
};
</script>
